import React from 'react';
import { Text } from '@atlaskit/primitives/compiled';

export const TaskDescriptionParagraph = ({
	children,
}: {
	children: React.ReactNode;
}): React.JSX.Element => {
	return (
		<Text size="medium" color="color.text.subtle">
			{children}
		</Text>
	);
};
